// Module
var code = "<template> <require from=\"./contact-box.scss\"></require> <div class=\"${selected==true ? 'selected' : '' }\" click.delegate=\"select()\" title=\"${title}\"> <span class=\"contact-text\">${email}</span> <span class=\"delete_button\" click.delegate=\"delete()\" t=\"[title]groups.add-members.delete\">\t☓</span> </div> </template> ";
// Exports
export default code;